function a(e,n){if(n===void 0){let t=new Set(e);return r=>t.has(r)}return n.includes(e)}export{a};
